"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FullPicker;
exports.FullWeekPicker = FullWeekPicker;
exports.formatISODateString = formatISODateString;

var React = _interopRequireWildcard(require("react"));

var _classify = _interopRequireDefault(require("../utils/classify"));

var _TimePicker = _interopRequireWildcard(require("./TimePicker.js"));

var _calendar = require("./calendar.js");

var _formatISO = _interopRequireDefault(require("date-fns/formatISO"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _compareAsc = _interopRequireDefault(require("date-fns/compareAsc"));

var _add = _interopRequireDefault(require("date-fns/add"));

var _sub = _interopRequireDefault(require("date-fns/sub"));

var _FullPickerModule = _interopRequireDefault(require("./FullPicker.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function FullPicker({
  onSelect,
  availability,
  size = "small"
}) {
  var _availability$formatI;

  const [month, setMonth] = React.useState(new Date());
  const [date, setDate] = React.useState(new Date());
  React.useEffect(() => {
    const dates = Object.keys(availability).sort((left, right) => (0, _compareAsc.default)((0, _parseISO.default)(left), (0, _parseISO.default)(right)));
    const firstDate = (0, _parseISO.default)(dates[0]);
    setDate(firstDate);
    setMonth(firstDate);
  }, [availability]);
  const possibleTimes = (_availability$formatI = availability[formatISODateString(date)]) !== null && _availability$formatI !== void 0 ? _availability$formatI : [];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      height: 390
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexFlow: "column"
    }
  }, /*#__PURE__*/React.createElement(_calendar.MonthPicker, {
    value: month,
    onChange: setMonth,
    size: size
  }), /*#__PURE__*/React.createElement(_calendar.CalendarHeader, {
    date: month,
    size: size
  }), /*#__PURE__*/React.createElement(_calendar.Grid, {
    month: month,
    eventDates: Object.keys(availability).map(parseLocalISODate),
    selectedDate: date,
    onChange: setDate,
    size: size
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flexFlow: "column",
      overflow: "scroll"
    }
  }, possibleTimes && date && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_calendar.DayHeader, {
    day: date,
    size: size
  }), /*#__PURE__*/React.createElement("p", {
    className: _FullPickerModule.default.scheduleDateSubtitle
  }, "Times with shared availability"), /*#__PURE__*/React.createElement(_TimePicker.default, {
    possibleTimes: possibleTimes,
    onSelect: time => {
      onSelect((0, _TimePicker.parseISOTime)(time, date));
    }
  }))));
}

function FullWeekPicker({
  onSelect,
  availability,
  size = "medium"
}) {
  var _availability$formatI2;

  const [calendarDate, setCalendarDate] = React.useState(new Date());
  const [date, setDate] = React.useState(new Date());
  React.useEffect(() => {
    const dates = Object.keys(availability).sort((left, right) => (0, _compareAsc.default)((0, _parseISO.default)(left), (0, _parseISO.default)(right)));
    const firstDate = (0, _parseISO.default)(dates[0]);
    setDate(firstDate);
    setCalendarDate(firstDate);
  }, [availability]);
  const possibleTimes = (_availability$formatI2 = availability[formatISODateString(date)]) !== null && _availability$formatI2 !== void 0 ? _availability$formatI2 : [];
  const eventDates = Object.keys(availability).map(d => (0, _parseISO.default)(d));
  const duration = React.useMemo(() => ({
    weeks: 1
  }));
  const handleNextClick = React.useCallback(() => {
    setCalendarDate((0, _add.default)(calendarDate, duration));
  }, [calendarDate]);
  const handlePreviousClick = React.useCallback(() => {
    setCalendarDate((0, _sub.default)(calendarDate, duration));
  }, [calendarDate]);
  return /*#__PURE__*/React.createElement("div", {
    className: _FullPickerModule.default.fullWeekPicker
  }, /*#__PURE__*/React.createElement("div", {
    className: _FullPickerModule.default.verticalPickerBox
  }, /*#__PURE__*/React.createElement(_calendar.VerticalWeekPicker, {
    date: calendarDate,
    selectedDate: date,
    eventDates: eventDates,
    onChange: setDate
  })), /*#__PURE__*/React.createElement("div", {
    className: _FullPickerModule.default.horizontalWeekPicker
  }, /*#__PURE__*/React.createElement("h3", null, calendarDate.toLocaleDateString(undefined, {
    month: "long",
    year: "numeric"
  })), /*#__PURE__*/React.createElement(_calendar.WeekPicker, {
    date: calendarDate,
    selectedDate: date,
    eventDates: eventDates,
    onChange: setDate,
    onPreviousWeekClick: handlePreviousClick,
    onNextWeekClick: handleNextClick,
    size: "small"
  })), /*#__PURE__*/React.createElement("div", {
    className: _FullPickerModule.default.timePickerBox
  }, possibleTimes && date && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_calendar.WeekDateHeader, {
    className: _FullPickerModule.default.weekDateHeader,
    date: date,
    onPreviousClick: handlePreviousClick,
    onNextClick: handleNextClick
  }), /*#__PURE__*/React.createElement(_TimePicker.default, {
    possibleTimes: possibleTimes,
    onSelect: time => {
      onSelect((0, _TimePicker.parseISOTime)(time, date));
    }
  }))));
}

function formatISODateString(date) {
  // returns the current _local_ YYYY-MM-DD for a date (i.e. not utc)
  return (0, _formatISO.default)(date, {
    representation: "date"
  });
}

function parseLocalISODate(string) {
  const [year, month, day] = string.split("-").map(num => parseInt(num, 10));
  return new Date(year, month - 1, day);
}